<template>
  <!-- -->
  <div class="detail">
    <list-page>
      <form-items class="form-data" :data="dataDetail" :columns="2" ref="form">
        <form-item label="方案名称" :required="true" name="solutionName" error-message="请输入方案名称">
          <el-input v-model="dataDetail.solutionName" placeholder="请输入方案名称"/>
        </form-item>
        <form-item label="方案类型">
          <el-select v-model="dataDetail.solutionType" >
            <el-option :value="1" label="通用方案"/>
            <el-option :value="2" label="定制方案"/>
          </el-select>
        </form-item>
        <form-item label="推荐规则">
          <el-select v-model="dataDetail.solutionRule">
            <el-option v-for="item in ruleList" :key="item.value" :label="item.name" :value="item.value"/>
          </el-select>
        </form-item>
        <form-item label="方案描述">
          <el-input v-model="dataDetail.solutionDesc" type="textarea"/>
        </form-item>
      </form-items>
      <list-table class="content-table" background-color="#FFF" :show-shadow="false">
        <yq-table :data="dataDetail.solutionRules" ref="table">
          <yq-table-column label="回复商品" prop="solutionFromName" :show-overflow-tooltip="true" />
          <yq-table-column label="推荐商品" prop="solutionToName" :show-overflow-tooltip="true" />
          <yq-table-column label="推荐权重" prop="solutionWeight" width="240rem">
            <template v-slot="{row}">
              <el-input v-model="row.solutionWeight" placeholder="请输入权重，默认为0" type="number"/>
            </template>
          </yq-table-column>
          <yq-table-column label="操作" prop="option" align="center">
            <template #header>
              <table-button @click="toUpdateLine({}, -1)">添加</table-button>
            </template>
            <template v-slot="{row, $index}">
              <table-button @click="toUpdateLine(row, $index)">修改</table-button>
              <table-button el-type="danger" @click="deleteRow($index)">删除</table-button>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
      <form-page :show-page="false">
        <page-button el-type="danger" @click="dataDetail.solutionRules = []">清空</page-button>
        <page-button el-type="primary" type="write" @click="saveTemplate">保存</page-button>
      </form-page>
    </list-page>
    <el-dialog v-model="showDetailLine" title="编辑方案明细" dialog-width="1">
      <form-items :data="currentData" :columns="1" label-width="2.4rem">
        <form-item label="回复商品">
          <el-tree-select v-model="currentData.solutionFrom" @change="changeFrom"  :data="productCategory" filterable clearable default-expand-all check-strictly :render-after-expand="false" placeholder="请选择上级" :props="{children: 'children', label: 'fullName'}" node-key="typeId"/>
        </form-item>
        <form-item label="推荐商品">
          <el-tree-select v-model="currentData.solutionTo" @change="changeTo" :data="productCategory" filterable clearable default-expand-all check-strictly :render-after-expand="false" placeholder="请选择上级" :props="{children: 'children', label: 'fullName'}" node-key="typeId"/>
        </form-item>
        <form-item label="推荐权重">
          <el-input v-model="currentData.solutionWeight" placeholder="请输入权重，默认为0" type="number"/>
        </form-item>
      </form-items>
      <template #footer>
        <el-button @click="showDetailLine = false">取消</el-button>
        <el-button type="primary" @click="updateLine">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage";
import ListTable from "@/components/h5/layout/ListTable.vue";
import FormPage from "@/components/h5/layout/FormPage";
import PageButton from "@/components/h5/button/PageButton";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import DialogTable from "@/components/h5/layout/DialogTable.vue";
import YqTable from "@/components/h5/table/YqTable.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import SeparatorPage from "@/components/h5/layout/SeparatorPage.vue";
import TreeDictionary from "@/components/h5/data/TreeDictionary.vue";
import qywxXbotSolutionApi from "@/api/dz-ai/qywxXbotSolutionApi";
import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import solutionRule from "./solutionRule.json";
export default {
  emits: ["changeId"],
  props: {
    id: {default: ""}, // 模板数据id
  },
  name: "",
  components: {
    TreeDictionary,
    TableButton,
    YqTableColumn,
    YqTable,
    PageButton, ListPage, ListTable, FormPage, FormItems, FormItem, DialogTable, SeparatorPage, SearchCondition
  },
  data() {
    return {
      dataDetail: {
        solutionName: "",
        solutionType: 2,
        solutionRule: "STOCK",
        solutionDesc: "",
        solutionRules: [],
      },
      ruleList: [],
      productCategory: [], // 商品分类
      currentIndex: null, // 当前正在编辑的行索引
      currentData: {
        relationId: "",
        btypeUserCode: "",
        btypeName: "",
        typeId: ""
      }, // 当前正在编辑的行数据
      showDetailLine: false, // 是否显示详情行弹窗
    };
  },
  created() {
    this.init();
    this.ruleList = solutionRule;
  },
  methods: {
    init() {
      if (this.id) {
        qywxXbotSolutionApi.findById(this.id).then(data => {
          this.dataDetail = data;
        })
      }
      // 查询商品分类
      qywxXbotSolutionApi.queryPtypeCategory().then(tree => {
        this.productCategory = tree;
      })
    },
    // 删除掉一行数据
    deleteRow(index) {
      if (index >= this.dataDetail.solutionRules.length) {
        // 刷新
        this.$refs.table.showDataColumns();
        return;
      }
      let data = this.dataDetail.solutionRules[index];
      if (data.id) {
        // 有这条数据
        qywxXbotSolutionApi.deleteRule(data.id).then(() => {
          this.dataDetail.solutionRules.splice(index, 1);
        })
      } else {
        this.dataDetail.solutionRules.splice(index, 1);
      }
      // 刷新
      this.$refs.table.showDataColumns();
    },
    changeFrom(data) {
      this.currentData.solutionFromName = this.getProductCategoryName(data, this.productCategory);
    },
    changeTo(data) {
      this.currentData.solutionToName = this.getProductCategoryName(data, this.productCategory);
    },
    getProductCategoryName(typeId, list) {
      for (let i = 0; i < list.length; i++) {
        if (typeId === list[i].typeId) {
          return list[i].fullName;
        }
        // 如果有下级分类，递归调用
        if (list[i].children && list[i].children.length > 0) {
          let name = this.getProductCategoryName(typeId, list[i].children);
          if (name) {
            return name;
          }
        }
      }
      return "";
    },
    // 添加一行
    toUpdateLine(data, index) {
      this.currentIndex = index;
      this.currentData = {...data};
      this.showDetailLine = true;
    },
    // 更新一行数据
    updateLine() {
      if (this.currentIndex === -1) { // 添加一条新的数据
        this.dataDetail.solutionRules.push(this.currentData);
      } else {
        this.dataDetail.solutionRules[this.currentIndex] = this.currentData;
      }
      // 刷新
      this.$refs.table.showDataColumns();
      this.showDetailLine = false;
    },
    // 保存数据
    saveTemplate() {
      if (!this.$refs.form.validCheck()) {
        return;
      }
      // 列表数据，如果有空，不能提交
      for (let i = 0; i < this.dataDetail.solutionRules.length; i++) {
        this.dataDetail.solutionRules[i].solutionRule = this.dataDetail.solutionRule; // 规则覆盖到子集
        if (!this.dataDetail.solutionRules[i].solutionFrom || !this.dataDetail.solutionRules[i].solutionTo) {
          this.$message.error(`第${i+1}行推荐规则未设置完成`)
          return;
        }
      }
      qywxXbotSolutionApi.saveTemplate(this.dataDetail).then(res => {
        this.dataDetail = res;
        this.$emit("changeId", res.id);
      })
    },

  }
};
</script>

<style lang="scss" scoped>
.detail{
  height: 100%;
  .form-data{
    padding: 20px 20px 0 20px;
    background-color: #FFF;
  }
  .content-table {
    padding: 20px;
  }
}
</style>